import {cl} from './common/functions';
import {$, __, variables} from './common/variables';
import {burgerMenuInit} from './components/burger-menu';
import {coffeeCounterInit} from './components/coffee-counter';
import {inputFileValue} from './components/html-components/input-file';
import {inputNumberValue} from './components/html-components/input-number';
import {inputRangeValue} from './components/html-components/input-range';
import {pictureErrorHandler} from './components/pictures-error';
import {progressBarInit} from './components/progress-bar';

/*
 * Pictures on error script
 * */
pictureErrorHandler();

/*
 * HTML5 elements behavior handle
 * */
inputRangeValue();
inputFileValue();

inputNumberValue();
// observer pour les rechargement ajax des elements
const targetNode = document.querySelector('form.woocommerce-cart-form');
if (!!targetNode) {
  // Options de l'observateur (quelles sont les mutations à observer)
  const config = {childList: true};
  // Fonction callback à éxécuter quand une mutation est observée
  const callback = function(mutationsList) {
    for (const mutation of mutationsList) {
      if (mutation.type == 'childList') {
        inputNumberValue();
      }
    }
  };
  // Créé une instance de l'observateur lié à la fonction de callback
  const observer = new MutationObserver(callback);
  // Commence à observer le noeud cible pour les mutations précédemment configurées
  observer.observe(targetNode, config);
}

/*
 * Burger Menu
 * */
burgerMenuInit();

/*
 * Counter
 * */
coffeeCounterInit();

/*
 * ProgressBar
 * */
progressBarInit(63, $('.grey-progressbar .wp-block-group__inner-container'));
progressBarInit(85, $('.red-progressbar .wp-block-group__inner-container'));
progressBarInit(70, $('.blue-progressbar .wp-block-group__inner-container'));
